var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{ref:"gridPage",attrs:{"form-default":{
            level: '100',
            status: 'activated',
        },"filters-default":{
            status: '',
            sort: 'name',
        },"filter-items":[
            {
                vModel: 'level',
                title: '権限',
                options: [
                    { text: '全て', value: '' },
                    { text: 'おみそ', value: '000' },
                    { text: '利用者', value: '100' },
                    { text: '管理者', value: '200' },
                    { text: '開発者', value: '300' } ],
            },
            {
                vModel: 'status',
                title: '状態',
                options: [
                    { text: '全て', value: '' },
                    { text: '仮登録', value: 'pending' },
                    { text: '登録済', value: 'activated' },
                    { text: '停止中', value: 'suspended' } ],
            } ],"filters-q-placeholder":"名前","form-modal-id":"user","search-action":"user/index","row-class":"flex-nowrap mx-0 my--2"},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('User',{attrs:{"model":form,"init":init},on:{"save":_vm.$refs.gridPage.save,"destroy":_vm.$refs.gridPage.destroy}})]}},{key:"column",fn:function(ref){
        var item = ref.item;
return [_c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"align-self-center flex-shrink-1"},[_c('b-form-checkbox',{attrs:{"value":true,"unchecked-value":false},model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}})],1),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"},[_c('div',{staticClass:"d-flex flex-nowrap bd-highlight"},[_c('div',{staticClass:"p-2 flex-grow-1 bd-highlight d-flex"},[_c('b-row',{staticClass:"no-gutters w-100"},[_c('b-col',{staticClass:"align-self-center",attrs:{"sm":"12"}},[_c('UserBadges',{staticClass:"mb-1",attrs:{"model":item}}),_vm._v(" "),_c('p',{staticClass:"mb-1 font-weight-bold"},[_vm._v("\n                                        "+_vm._s(item.email)+"\n                                    ")])],1)],1)],1)])])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }